import { ReactNode, useEffect, useState } from 'react';

import { HISTORY_ITEMS_EVENT_NAME } from '../../constants/recentGenerations';
import { RecentGenerationMetadata } from '../../interfaces/recentGeneration';

import HistoryContext from './context';

interface HistoryProviderProps {
  children: ReactNode;
}

export const HistoryProvider = ({ children }: HistoryProviderProps) => {
  const [historyItems, setHistoryItems] = useState<RecentGenerationMetadata[]>(
    [],
  );

  const loadHistoryItems = () => {
    if (typeof window === 'undefined') return;

    const recentGenerations = localStorage.getItem('recentGenerationsList');
    if (!recentGenerations) {
      setHistoryItems([]);
      return;
    }

    try {
      const recentGenerationsList = JSON.parse(recentGenerations);
      if (Array.isArray(recentGenerationsList)) {
        setHistoryItems(recentGenerationsList);
      } else {
        console.error(
          'Parsed history items are not an array:',
          recentGenerationsList,
        );
        setHistoryItems([]);
      }
    } catch (error) {
      console.error('Error parsing history items:', error);
      setHistoryItems([]);
    }
  };

  useEffect(() => {
    loadHistoryItems();

    const handleHistoryItemsChange = () => {
      loadHistoryItems();
    };

    window.addEventListener(HISTORY_ITEMS_EVENT_NAME, handleHistoryItemsChange);

    return () => {
      window.removeEventListener(
        HISTORY_ITEMS_EVENT_NAME,
        handleHistoryItemsChange,
      );
    };
  }, []);

  return (
    <HistoryContext.Provider
      value={{
        historyItems,
        setHistoryItems,
      }}
    >
      {children}
    </HistoryContext.Provider>
  );
};
